import React, { useMemo } from 'react';
import classNames from 'classnames';
import type { ActiveTabType } from '@components/Modals/ApprovalModal/ApprovalModal/components/CreatingApprovalStep/CreatingApprovalStep';
import {
  ApprovalRoutingIcon,
  ApprovalRoutingSettingsIcon,
  TemplateIcon
} from '@icons';
import './ProcessTabs.less';

type ProcessTabsProps = {
  activeTab: ActiveTabType;
  disabled?: boolean;
  hasApprovalWorkflowSplit?: boolean;
  setActiveTab: (value: ActiveTabType) => void;
};

export default function ProcessTabs({
  activeTab,
  disabled = false,
  hasApprovalWorkflowSplit = false,
  setActiveTab
}: ProcessTabsProps) {
  const items = useMemo(() => {
    return [
      {
        key: 'create' as const,
        icon: <ApprovalRoutingIcon />,
        title: 'New approval routing',
        text: 'Create approval routing from scratch.'
      },
      {
        key: 'useTemplate' as const,
        icon: <TemplateIcon />,
        title: 'Use template',
        text: 'Use template with preset stages and reviewers.'
      },
      ...(hasApprovalWorkflowSplit
        ? [
            {
              key: 'awSplitCopy' as const,
              icon: <ApprovalRoutingSettingsIcon />,
              title: 'Preserve parent routing settings',
              text: 'Use predefined stages and reviewers from the original approval flow.',
              className: 'b-full'
            }
          ]
        : [])
    ];
  }, [hasApprovalWorkflowSplit]);

  return (
    <div className="process-tabs tour-route-for-approval-tabs">
      {items.map((item) => (
        <div
          key={item.key}
          className={classNames('process-tabs-item', item.className, {
            'b-selected': activeTab === item.key,
            'b-disabled': disabled
          })}
          onClick={() => !disabled && setActiveTab(item.key)}
        >
          <div className="process-tabs-item-head">
            <div className="process-tabs-item-icon">{item.icon}</div>
            <div className="process-tabs-item-title">{item.title}</div>
          </div>
          <div className="process-tabs-item-text">{item.text}</div>
        </div>
      ))}
    </div>
  );
}
